import { Tooltip } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (element) {
    new Tooltip(element);
  });
});
